export default __webpack_public_path__ + "static/media/icaew_s.ff400da5.jpg";